<template>
    <div class="info-warpper">
        <div class="bg-white" v-if="info">
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="小区" span="2">{{ info.xiaoqu_name }}</el-descriptions-item>
                <el-descriptions-item label="楼门户" span="2">{{ info.building_name }}-{{ info.element_name
                    }}-{{ info.room_name }}
                </el-descriptions-item>
                <!--                <el-descriptions-item label="姓名">{{ info.name }}</el-descriptions-item>-->
                <!--                <el-descriptions-item label="手机号">{{ info.phone }}</el-descriptions-item>-->
                <!--                <el-descriptions-item label="年龄">{{ info.age ? info.age : '-' }}</el-descriptions-item>-->
                <el-descriptions-item label="专属管家">
                    <div class="flex align-center justify-between">
                        <p> {{ info.guanjia }}</p>
                        <el-button size="small" type="danger" @click="guanjiaDialog = true"
                                   v-if="user.power === 5">修改
                        </el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="专业人员">
                    <div class="flex align-center justify-between">
                        <p>{{ info.exclusive_personnel_name }} - {{ info.exclusive_personnel_phone }}</p>
                        <el-button size="small" type="danger" @click="zhuanyeDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="紧急联系人">
                    <div class="flex align-center justify-between">
                        <p> {{ info.emergency_contact ? info.emergency_contact : '-' }}</p>
                        <el-button size="small" type="danger" @click="lianxiDialog = true">修改</el-button>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
           <div class="flex align-center justify-between margin-top-sm">
               <div class="title ">设备信息</div>
               <el-button
                   size="small"
                   type="danger"
                   @click="addItem(false)">绑定设备
               </el-button>
           </div>
            <el-table
                :data="devList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                class="margin-top-sm"
                align="center"
                border
                style="width: 100%">
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="类型" prop="type">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.type | devTypeList }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="编号">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.dev_id }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="danger"
                                @click="addItem(scope.row)">修改
                            </el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="delItem(scope.row)">解绑
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <guanjiaDialog
            :admin_id="admin_id"
            :accountList="accountList"
            :guanjiaDialog="guanjiaDialog"
            @cancelDialog="cancelDialog"/>
        <zhuanyeDialog
            :exclusive_personnel_id="exclusive_personnel_id"
            :exclusivePersonnelList="exclusivePersonnelList"
            :zhuanyeDialog="zhuanyeDialog"
            @cancelDialog="cancelDialog"/>

        <lianxiDialog
            :lxrName="lxrName"
            :lxrPhone="lxrPhone"
            :lianxiDialog="lianxiDialog"
            @cancelDialog="cancelDialog"/>

        <safety-dev-dialog
            :set-item="setItem"
            :set-id="setId"
            :room_id="id"
            :dialog="safetyDevDialog"
            @cancelDialog="cancelDialog"></safety-dev-dialog>

    </div>
</template>

<script>

import { getExclusivePersonnelList,} from "@/api/service";
import guanjiaDialog from "@/views/serve/dialog/SafetyGuanjiaDialog";
import zhuanyeDialog from "@/views/serve/dialog/SafetyZhuanyeDialog";
import lianxiDialog from "@/views/serve/dialog/SafetyLianxiDialog";
import {getAdminList} from "@/api/login";
import SafetyDevDialog from "@/views/serve/dialog/SafetyDevDialog";
import {devTypeList, filesCN} from "@/utils/utils";
import {delRoomDevice, getRoomDetails, getRoomDeviceList} from "@/api/houst";

export default {
    name: "service-safety-detail",
    data() {
        return {
            id: '',
            info: null,
            devList: [],

            setId: 0,
            setItem: {},

            zhuanyeDialog: false,
            lianxiDialog: false,
            guanjiaDialog: false,
            safetyDevDialog: false,

            exclusivePersonnelList: [],
            exclusive_personnel_id: 0,
            accountList: [],
            admin_id: 0,

            lxrName: '',
            lxrPhone: '',


        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.id = this.$route.params.id
        this.$emit("setIndex",
            this.$route.path.includes('housing') ?'/home/housing-data' : '/home/safety-dev',
            this.$route.path.includes('housing') ? "房屋数据 / 设备管理" :"预警中心 / 安全守护", true);
        this.getDetail()
        this.getSafetyDevList()
        this.getExclusivePersonnelList()
        if (this.user.power === 5) this.getAdminList()

    },
    components: {
        SafetyDevDialog,
        zhuanyeDialog, lianxiDialog, guanjiaDialog
    },
    methods: {
        //  获取物业管家列表
        async getAdminList() {
            let _list = await getAdminList('', '', 6, 1, 999)
            this.accountList = _list.data
        },
        //  获取专业人员列表
        async getExclusivePersonnelList() {
            let _list = await getExclusivePersonnelList(1, 999)
            this.exclusivePersonnelList = _list.data
        },
        async getDetail() {
            const res = await getRoomDetails(this.id)
            this.info = res.data
            this.exclusive_personnel_id = res.data.exclusive_personnel_id ? res.data.exclusive_personnel_id : 0
            if (res.data.emergency_contact) {
                let _arr = res.data.emergency_contact.split('-')
                this.lxrName = _arr[0]
                this.lxrPhone = _arr[1]
            }

            if (res.data.guanjia) {
                this.admin_id = res.data.admin_id
            }
            if (res.data.service_demand_situation) {
                this.server = JSON.parse(res.data.service_demand_situation)
            }

        },
        async getSafetyDevList() {
            let _data = await getRoomDeviceList(this.id)
            this.devList = _data.data
        },
        //  删除
        delItem(item) {
            this.$confirm('您确定要解绑该设备吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(item.id);
            });
        },
        async sureDelete(id) {
            let _state = await delRoomDevice(id);
            this.getSafetyDevList();
            this.$message.success(_state.info);
        },
        //  编辑
        addItem(obj) {
            if (obj) {
                this.setItem = obj;
                this.setId = obj.id;
            }
            this.safetyDevDialog = true
        },

        cancelDialog(val) {
            if (val) {
                this.setId = 0;
                this.setItem = {};
                this.lianxiDialog = false;
                this.safetyDevDialog = false;
                this.zhuanyeDialog = false;
                this.guanjiaDialog = false;
                this.getSafetyDevList()
                this.getDetail()
            } else {
                this.setId = 0;
                this.setItem = {};
                this.lianxiDialog = false;
                this.safetyDevDialog = false;
                this.zhuanyeDialog = false;
                this.guanjiaDialog = false;
            }
        },

    },
    filters: {
        devTypeList(val) {
            return filesCN(Number(val), devTypeList)
        }
    },
    watch: {},
}
</script>

<style scoped lang="scss">
.echarts {
    width: 48%;
    height: 300px;
}
.title {
    font-size: 16px;
    font-weight: 600;
}
</style>


